// api
import { components } from "./schema";

export type APIResponse = components["responses"];

export type Barometer = components["schemas"]["Barometer"];
export type Method = Barometer["method"];

// Regular
export enum PageType {
  science = "videnskabelig_publicering",
  method = "undersøgelsens_metode",
  evidence = "samlet_evidens",
  notes = "særlige_bemærkninger",
}

export interface SingularPage {
  type: PageType;
  title: string;
}
